
import { CustomLoading } from 'common'


export const ReportViewer = ({ useFetchInit, dataModal }) =>{

    const {
        FetchData
    } = useFetchInit

    const { fetchSpecificVehicleReception } = FetchData
    const { exitPassReportBase64, returnCertificateReportBase64, loadingFetchSpecificRate } = fetchSpecificVehicleReception
    // const { docName, docBase64 } = exitPassReportBase64

    const { dataRequest } = dataModal
    const { docType } = dataRequest

    console.log('docType ::: ', docType)

    
    const docName = docType === 'EXIT_PASS' ? exitPassReportBase64.docName : returnCertificateReportBase64.docName
    const docBase64 = docType === 'EXIT_PASS' ? exitPassReportBase64.docBase64 : returnCertificateReportBase64.docBase64

    return(
        <>
            {(loadingFetchSpecificRate)&&(<CustomLoading/>)}
            {(!loadingFetchSpecificRate && (docBase64 || docBase64 !== ''))&&(
                <iframe
                    src={docBase64 || null}
                    width="100%"
                    height="700"
                    style={{ border: "none" }}
                    title={docName}
                />
            )}
        </>
    )
}